import { Helmet } from 'react-helmet-async';
import ClinicAddProductView from 'src/sections/clinic-dashboard/products/products-add-view';

export default function ClinicAddProductPage() {
  return (
    <>
      <Helmet>
        <title>Add Product</title>
      </Helmet>

      <ClinicAddProductView />
    </>
  );
}
